export default __webpack_public_path__ + "static/media/Gold Star.f1b0ad97.png";